<div class="products-container">
  <h3 class="section-title">
    <i class="pi pi-box mr-2"></i>
    Produits
  </h3>

  <div *ngIf="products?.length" class="products-list">
    <div *ngFor="let item of products" class="product-item">
      <p-chip
        [label]="item.product.name"
        [style]="{ 'background-color': item.product.color, color: 'white' }"
        styleClass="custom-chip"
      ></p-chip>
      <span class="product-info"
        >× {{ item.quantity }} -
        {{
          item.price * item.quantity
            | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
        }}</span
      >
    </div>

    <div class="total-section">
      <span>Total</span>
      <span class="total-value">{{
        totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
      }}</span>
    </div>
  </div>

  <div *ngIf="!products?.length" class="empty-message">
    Aucun produit associé
  </div>
</div>
